import { rawUrlEncode } from '@vs-shop/domain/string/rawUrlEncode';
import { pipe, String } from 'effect';

/**
 * Encodes a product or variant code for a `{code}` path segment of the rcprofi
 * backend.
 *
 * The backend routes on the decoded path, so a single `%2F` becomes a path
 * separator and the route 404s. A `/` in the code therefore travels as
 * `%252F`: `/products/AD-SH-PKN4301%252FS/expand` answers 200, while
 * `/products/AD-SH-PKN4301%2FS/expand` answers 404. Every other character
 * keeps its single `rawUrlEncode` escape.
 */
export const encodeProductPathCode = (code: string): string =>
  pipe(rawUrlEncode(code), String.replaceAll('%2F', '%252F'));
